"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _systemSetting = require("@/api/systemSetting");
var _linkaddress = _interopRequireDefault(require("@/components/linkaddress"));
var _pagesHeader = _interopRequireDefault(require("@/components/base/pagesHeader"));
var _qrcodejs = _interopRequireDefault(require("qrcodejs2"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'content',
  components: {
    linkaddress: _linkaddress.default,
    pagesHeader: _pagesHeader.default
  },
  data: function data() {
    return {
      formItem: {
        smallTickerHeader: 1,
        deliveryInfo: 1,
        buyerRemark: 1,
        productInfo: 1,
        freightInfo: 1,
        discountInfo: 1,
        payInfo: [1, 2],
        orderInfo: [1, 2],
        codeUrlSwitch: 0,
        codeUrl: '',
        bottomNoticeSwitch: 0,
        bottomNotice: '',
        id: Number(this.$route.params.id)
      },
      codeUrl: '',
      id: Number(this.$route.params.id),
      sideBar1: this.$store.state.themeConfig.themeConfig.isCollapse
    };
  },
  computed: {
    collapseShow: function collapseShow() {
      return ['defaults', 'columns'].includes(this.$store.state.themeConfig.themeConfig.layout);
    }
  },
  created: function created() {
    // this.getMerId();
    if (this.id) this.getPrintContent();
  },
  methods: {
    getPrintContent: function getPrintContent() {
      var _this = this;
      (0, _systemSetting.getPrintContentApi)(this.id).then(function (res) {
        if (!res) return;
        _this.formItem = res;
        if (res.codeUrl) {
          _this.codeUrl = res.codeUrl;
          _this.$nextTick(function (e) {
            _this.drawCode(_this.codeUrl);
          });
        }
      });
    },
    save: function save() {
      var _this2 = this;
      this.formItem.id = this.id;
      (0, _systemSetting.savePrintContentApi)(this.formItem, this.formItem.id).then(function (res) {
        _this2.$message.success('保存成功');
      }).catch(function (err) {
        _this2.$message.error(err);
      });
    },
    getLink: function getLink() {
      this.$refs.linkaddres.dialogVisible = true;
      this.$refs.linkaddres.currenType = 'link';
    },
    linkUrl: function linkUrl(e, op) {
      var url = '';
      if (op != '自定义链接') {
        url = this.$selfUtil.getFrontDomainUrl() + e;
      } else {
        url = e;
      }
      this.drawCode(url);
      this.formItem.codeUrl = url; // 大粽子 这里直接给后段全路径 提交和渲染同步修改 并且约定 自定义链接 文本不能随意更改
    },
    drawCode: function drawCode(url) {
      var qrcode = '';
      var obj = document.getElementById('qrcode');
      obj.innerHTML = '';
      qrcode = new _qrcodejs.default(obj, {
        text: url,
        // 需要转换为二维码的内容
        width: 128,
        height: 128,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: _qrcodejs.default.CorrectLevel.H
      });
    }
  }
};